export type LoopPhase = {
  index: string
  title: string
  body: string
}

export const loopPhases: LoopPhase[] = [
  {
    index: '01',
    title: 'Maintain',
    body: 'Hosting, monitoring, support, content, and configuration remain current.',
  },
  {
    index: '02',
    title: 'Measure',
    body: 'Track search visibility, leads, orders, system health, and customer behavior.',
  },
  {
    index: '03',
    title: 'Recommend',
    body: 'Turn reports and business changes into clear, practical priorities.',
  },
  {
    index: '04',
    title: 'Improve',
    body: 'Update pages, forms, chat, workflows, integrations, and automation.',
  },
]

export type ServiceGroup = {
  title: string
  items: string[]
}

export const serviceGroups: ServiceGroup[] = [
  {
    title: 'Maintain',
    items: ['Managed hosting, SSL, backups, and monitoring', 'Content and configuration changes', 'Support and training'],
  },
  {
    title: 'Grow',
    items: ['SEO, content, and reporting', 'Lead-flow and conversion improvements'],
  },
  {
    title: 'Extend',
    items: ['Integration enhancements', 'Automation and new functionality'],
  },
]
